import { call, put, takeEvery, select } from "redux-saga/effects";

import { loaderUserPayoutConditions, setUserPayoutConditions } from "./actions";
import { userGetProfile } from "../user/actions";
import { ADD_USER_PAYOUT_CONDITIONS, DELETE_USER_PAYOUT_CONDITIONS, GET_USER_PAYOUT_CONDITIONS, UPDATE_USER_PAYOUT_CONDITIONS } from "./actionTypes";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../helpers/utils";
import { addUserPayoutConditionApi, deleteUserPayoutConditionApi, getUserPayoutConditionApi, patchUserPayoutConditionApi } from "../../helpers/jwt_helper";


function* onGetUserPayoutConditions({ payload: data }) {
  try {
    yield put(loaderUserPayoutConditions());
    let response = yield call(getUserPayoutConditionApi, {
      ...data,
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setUserPayoutConditions(response));
    yield put(loaderUserPayoutConditions());
  } catch (error) {
    yield put(loaderUserPayoutConditions());
  }
}

function* onAddUserPayoutConditions({ payload: { user_id, data } }) {
  try {

    yield put(loaderUserPayoutConditions());
    yield call(addUserPayoutConditionApi, data);
    showSuccessMessage(
      `Payout Condition has been added successfully`
    );
    yield put(userGetProfile(user_id))
    // yield call(onGetUserPayoutConditions, {
    //   payload: yield select(state => state.UserPayoutConditions.data),
    // });
    yield put(loaderUserPayoutConditions());
  } catch (e) {
    yield put(loaderUserPayoutConditions());
    getErrorMessage(showErrorMessage(e));
  }
}

function* onDeleteUserPayoutConditions({ payload: { user_id, id } }) {
  try {
    yield put(loaderUserPayoutConditions());
    yield call(deleteUserPayoutConditionApi, id);
    yield put(userGetProfile(user_id))
    // yield call(onGetUserPayoutConditions, {
    //   payload: yield select(state => state.UserPayoutConditions.data),
    // });
    yield put(loaderUserPayoutConditions());
    showSuccessMessage(`Payout condition has been deleted successfully`);
  } catch (error) {
    yield put(loaderUserPayoutConditions());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateUserPayoutConditions({ payload: { user_id, id, data } }) {
  try {
    yield put(loaderUserPayoutConditions());
    yield call(patchUserPayoutConditionApi, id, data);
    yield put(userGetProfile(user_id))
    // yield call(onGetUserPayoutConditions, {
    //   payload: yield select(state => state.UserPayoutConditions.data),
    // });
    yield put(loaderUserPayoutConditions());
    showSuccessMessage(`Updating payout condition has been successfully`);
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(loaderUserPayoutConditions());
  }
}

function* userPayoutConditionsSaga() {
  yield takeEvery(GET_USER_PAYOUT_CONDITIONS, onGetUserPayoutConditions);
  yield takeEvery(ADD_USER_PAYOUT_CONDITIONS, onAddUserPayoutConditions);
  yield takeEvery(DELETE_USER_PAYOUT_CONDITIONS, onDeleteUserPayoutConditions);
  yield takeEvery(UPDATE_USER_PAYOUT_CONDITIONS, onUpdateUserPayoutConditions);

}

export default userPayoutConditionsSaga;
